$shm_hitalama_map_widget_float_customdom $shm_hitalama_map_widget_float
	content /
		^ customdom_content /
			<= Dom_wrapper null
	Dump $mol_dump_value
		value <= result null
	Error $mol_view
		sub /
			<= Copy_error $mol_button_copy
				title <= error? \
